import PropTypes from "prop-types";
import React from "react";

import * as S from "../Steps/Step2/Step2.styles";

const CadastroPlanSelector = ({ plans, selectedPlan, onSelect }) => {
  return (
    <S.PlanSelectorWrapper
      className="blocksPrice mt-6"
      data-testid="register-plan-selector"
    >
      <S.PlanGrid
        $count={plans.length}
        data-testid="register-plan-grid"
      >
        {plans.map(plan => (
          <button
            type="button"
            className={
              "col-sm-3 " + (selectedPlan?.id === plan.id ? "active" : "")
            }
            style={{ background: "none" }}
            aria-pressed={selectedPlan?.id === plan.id}
            onClick={() => onSelect(plan)}
            key={plan.id}
          >
            <span>{plan.name}</span>
            {plan.coupon && plan.coupon.oldAmount !== plan.coupon.amount && (
              <h3 className="cut">R$ {plan.coupon.oldAmount}</h3>
            )}
            <h3>
              R$ {plan.coupon ? plan.coupon.amount : plan.amount}
            </h3>
          </button>
        ))}
      </S.PlanGrid>

      {selectedPlan?.coupon && (selectedPlan.coupon.description || selectedPlan.coupon.subtitle) && (
        <div data-testid="register-plan-coupon-discount" className="mt-4">
          {selectedPlan.coupon.description && (
            <p
              className="font-size-h3 preto-cabecalho font-weight-bolder mb-0"
              style={{ opacity: 0.8 }}
            >
              {selectedPlan.coupon.description}
            </p>
          )}
          {selectedPlan.coupon.subtitle && (
            <p
              className="font-size-sm preto-cabecalho mb-0"
              style={{ opacity: 0.8 }}
            >
              {selectedPlan.coupon.subtitle}
            </p>
          )}
        </div>
      )}
    </S.PlanSelectorWrapper>
  );
};

const couponShape = PropTypes.shape({
  code: PropTypes.string,
  amount: PropTypes.string,
  oldAmount: PropTypes.string,
  description: PropTypes.string,
  subtitle: PropTypes.string,
});

CadastroPlanSelector.propTypes = {
  plans: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      gateway_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
      name: PropTypes.string.isRequired,
      amount: PropTypes.string.isRequired,
      type: PropTypes.oneOf(["monthly", "one_time"]).isRequired,
      coupon: couponShape,
    })
  ).isRequired,
  selectedPlan: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.oneOf(["monthly", "one_time"]),
    coupon: couponShape,
  }),
  onSelect: PropTypes.func.isRequired,
};

CadastroPlanSelector.defaultProps = {
  selectedPlan: null,
};

export default CadastroPlanSelector;
